import "../../styles/theme.scss";

import $ from 'jquery';

window.jQuery = $;
window.$ = $;
import { Foundation } from 'foundation-sites/js/foundation.core';
import { Keyboard } from 'foundation-sites/js/foundation.util.keyboard';
import { Accordion } from 'foundation-sites/js/foundation.accordion';
import { OffCanvas } from 'foundation-sites/js/foundation.offcanvas';
import { Sticky } from 'foundation-sites/js/foundation.sticky';
import { Toggler } from 'foundation-sites/js/foundation.toggler';
import initQuantityInputButtons from "../lib/quantity-input-buttons";
import ShopifyFiltering from "../lib/filtering";
import initAjaxCart from '../lib/cart';
import initAjaxNewsletter from '../lib/ajax-newsletter';
import Cookie from 'js-cookie';

Foundation.addToJquery($);

Foundation.Keyboard = Keyboard;

Foundation.plugin(Accordion, 'Accordion');
Foundation.plugin(OffCanvas, 'OffCanvas');
Foundation.plugin(Sticky, 'Sticky');
Foundation.plugin(Toggler, 'Toggler');

$(document).foundation();

new ShopifyFiltering($('#sort-by'));
initQuantityInputButtons();
initAjaxCart();

if (navigator.cookieEnabled) {
  document.documentElement.className = document.documentElement.className.replace(
    'supports-no-cookies',
    'supports-cookies',
  );
}

$(document).ready(() => {
  const $shopNotice = $('.newsletter-slideup');

  if ($shopNotice.length > 0) {
    if ('yes' !== Cookie.get('shopNoticeClosed')) {
      $shopNotice.addClass('active');

      setTimeout(function () {
        $shopNotice.addClass('visible');
      }, 1200);
    }

    $shopNotice.on('click', '.shop-notice-close', function () {
      Cookie.set('shopNoticeClosed', 'yes', {
        expires: 28,
      });

      $shopNotice.removeClass('visible');

      setTimeout(function () {
        $shopNotice.removeClass('active');
      }, 1200);
    });
  }

  initAjaxNewsletter();
});
